import { render, staticRenderFns } from "./goodsspu.vue?vue&type=template&id=13aae3b0&scoped=true&"
import script from "./goodsspu.vue?vue&type=script&lang=js&"
export * from "./goodsspu.vue?vue&type=script&lang=js&"
import style0 from "./goodsspu.vue?vue&type=style&index=0&id=13aae3b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aae3b0",
  null
  
)

export default component.exports